import { TwoCol, SubSection } from "./fundCardHelpers";
import { InfoRow } from "../UI";

export default function SummaryTab({ fund, cs }) {
  return (
    <TwoCol>
      <SubSection title="פרטי חשבון" color={cs.accent}>
        <InfoRow label="מספר פוליסה / חשבון" value={fund.polNum} />
        <InfoRow label="תאריך הצטרפות" value={fund.joinDate} />
        <InfoRow label="הצטרפות ראשונה" value={fund.firstJoinDate} />
        <InfoRow label="תאריך נכונות" value={fund.validDate} />
        <InfoRow label="עדכון סטטוס" value={fund.statusUpdateDate} />
        <InfoRow label="פנסיה ותיקה/חדשה" value={fund.pensiaVatika} />
        <InfoRow label="מסלול ביטוח" value={fund.maslulBituach} />
        <InfoRow label="תיקון 190" value={fund.tikun190} />
        <InfoRow label="מדד בסיס" value={fund.madad} />
      </SubSection>
      <SubSection title="נתונים כספיים עיקריים" color={cs.accent}>
        <InfoRow label="ערך פדיון" value={fund.redeem} money bold color={cs.accent} />
        <InfoRow label="יתרה סוף שנה קודמת" value={fund.prevYear} money />
        <InfoRow label="רווח / הפסד" value={fund.returns?.profitLoss} money bold color="#16a34a" />
        <InfoRow label="תשואה נטו" value={fund.returns?.neto} pct />
        <InfoRow label="תשואה ברוטו" value={fund.returns?.bruto1 || fund.returns?.bruto2} pct />
        <InfoRow label="תשואה מובטחת" value={fund.returns?.guaranteed} pct />
        <InfoRow label="מקצוע לביטוח" value={fund.profession} />
        {(fund.cat === "קופת גמל" || fund.cat === "קרן השתלמות" || fund.cat === "קופת גמל להשקעה") && (
          <>
            <InfoRow label="מועד נזילות תגמולים"       value={fund.yitrot?.tagmulimLiquidity} />
            <InfoRow label="יתרת כספי תגמולים נזילים"  value={fund.yitrot?.tagmulimBalance} money />
            {fund.cat === "קרן השתלמות" && (
              <InfoRow
                label="תקרת הפקדה מועדפת"
                value={{ "1": "עד התקרה", "2": "מעל התקרה" }[fund.yitrot?.tikratHafkada]}
              />
            )}
            <InfoRow label="שעבוד" value={{ "1": "כן", "2": "לא", "3": "לא ידוע" }[fund.shiabud]} />
            <InfoRow label="עיקול"  value={{ "1": "כן", "2": "לא", "3": "לא ידוע" }[fund.ikul]}  />
          </>
        )}
      </SubSection>
    </TwoCol>
  );
}
